export const FETCH_TIMELINE_PAGINATION = 'FETCH_TIMELINE_PAGINATION'

export const RECEIVE_TIMELINE_PAGINATION = 'RECEIVE_TIMELINE_PAGINATION'

export const RECEIVE_TIMELINE_LIST_INCREASE = 'RECEIVE_TIMELINE_LIST_INCREASE'

export const RECEIVE_LIST_PAGINATION = 'RECEIVE_LIST_PAGINATION'

export const POST_INTERATION = 'POST_INTERATION'

export const DONE_INTERATION = 'DONE_INTERATION'

export const CLEAN_TIMELINE_LIST = 'CLEAN_TIMELINE_LIST'

export const FETCH_TIMELINE_LIST = 'FETCH_TIMELINE_LIST'

export const RECEIVE_TIMELINE_LIST = 'RECEIVE_TIMELINE_LIST'

export const RECEIVE_TIMELINE_LIST_METADATA = 'RECEIVE_TIMELINE_LIST_METADATA'

export const RECEIVE_TIMELINE_LIST_FILTERS = 'RECEIVE_TIMELINE_LIST_FILTERS'

export const REMOVE_TIMELINE_LIST_FILTERS = 'REMOVE_TIMELINE_LIST_FILTERS'

export const RESET_TIMELINE_LIST_FILTERS = 'RESET_TIMELINE_LIST_FILTERS'

export const FETCH_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT =
  'FETCH_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT'

export const RECEIVE_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT =
  'RECEIVE_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT'

export const CLEAR_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT =
  'CLEAR_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT'
